/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'

export function GloModel(props) {
  const glo = useRef(null)
  const { nodes, materials } = useGLTF('/data/glo.glb')

  useFrame(({clock}) => {
    glo.current.rotation.y = clock.getElapsedTime()/3
  })
  
  return (
    <group ref={glo} {...props} dispose={null}>
      <group position={[-1.787, 1.623, 3.217]} rotation={[-0.191, 0.575, 0.61]}>
        <group position={[4.274, -0.665, -1.156]} scale={0.143}>
          <group rotation={[0, 0.275, 0]}>
            <group position={[0.124, 8.788, -0.365]} rotation={[0.597, 0.499, -0.502]}>
              <group position={[0, -27.639, -0.144]} rotation={[-Math.PI / 2, 0, Math.PI]}>
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.ekranik.geometry}
                  material={materials.ekranik}
                  position={[0, -0.7, 0]}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.glo_11.geometry}
                  material={materials.C5_glo1}
                  material-color="#b55779"
                  material-metalness={0.9}
                  material-roughness={0.4}
                  position={[2.547, 122.642, -2.519]}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.glo_21.geometry}
                  material={materials.C5_glo2}
                  material-color="#b55779"
                  material-metalness={1}
                  material-roughness={0.3}
                  position={[2.547, 122.642, -2.519]}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.kolko.geometry}
                  material={materials.C5_kolko}
                  material-color="#b55779"
                  material-metalness={1}
                  material-roughness={0.3}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.napisy_alpha.geometry}
                  material={materials['napisy ']}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.ring.geometry}
                  material={materials.C5_ring}
                  material-color="#b55779"
                  material-metalness={1}
                  material-roughness={0.3}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.ring_cienki.geometry}
                  material={materials.C5_ring_cienki}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.usbc_box.geometry}
                  material={materials['plastik ciemny']}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.usbc_metal.geometry}
                  material={materials.metal}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.wlot.geometry}
                  material={materials.C5_wlot}
                  material-color="#b55779"
                  material-metalness={1}
                  material-roughness={0.3}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.zaslepka.geometry}
                  material={materials.zaslepka}
                />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

// // useGLTF.preload('/data/glo.glb')